import { DailyGameFields, getDailyGameSrc } from '@/lib/drupal/models/Games';

function cleanDrupalUrl (url: string) {
  return url.replace(/&amp;/g, '&');
}

export function useDailyGameSrc (
  rawGameSrc: string, 
  fields: DailyGameFields, 
  theme?: 'light' | 'dark',
  jwt?: string
) {
  const url = cleanDrupalUrl(rawGameSrc);
  const urlParts = url.split('?');
  const urlParams = new URLSearchParams(getDailyGameSrc(urlParts[ 1 ] || '', fields));

  if (theme) urlParams.set('theme', theme);
  if (jwt) urlParams.set('jwt', jwt);
  if (process.env.NEXT_PUBLIC_HOST_ENV !== 'production') urlParams.set('env', 'staging');

  return urlParts[ 0 ] + '?' + decodeURIComponent(urlParams.toString());
}
